import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import { MainPageTitle } from "@/entities/main-page-title";
import { AppButton } from "@/shared/Components";
import { SupportLinks } from "@/common/SupportLinks";
import { useGoToLogin } from "@/entities/success-payment/model";
import styles from "./styles.module.scss";

export const Desktop = () => {
  const { t } = useTranslation();

  const { goToLogin } = useGoToLogin();

  return (
    <Flex vertical gap={24}>
      <MainPageTitle
        title={t("registrationPage.successPayment.title")}
        subtitle={t("registrationPage.successPayment.subtitle")}
      />
      <SupportLinks gap={16} iconStroke="#FAAD14" className={styles.support} />
      <AppButton type="primary" onClick={goToLogin}>
        {t("registrationPage.blockedStep.goToLogin")}
      </AppButton>
    </Flex>
  );
};
